<div nz-row>
  <div nz-col nzSpan="24" style="margin-bottom: 1rem;" class="no-form">
    <h1>Riattiva identità</h1>
  </div>
</div>
<div class="centered-box-vertical large">
  <span>È possibile riattivare l'identità digitale SPID. Per riattivare'identità digitale inserisci il
    codice di emergenza e l'OTP che riceverai sul numero di cellulare associato all'identità.</span>
  <nz-spin nzTip="Invio richiesta..." [nzSpinning]="isSpinning">
    <form autocomplete="off" nz-form class="custom-form" [formGroup]="validateForm">
      <div nz-row nzJustify="start" [nzGutter]="20" nzAlign="top">
        <div nz-col nzSpan="24" class="no-form">
          <nz-form-item class="login">
            <nz-form-control [nzErrorTip]="getValidationErrorMessage(validateForm.controls.emergencyCode.errors)">
              <nz-input-group nzPrefixIcon="lock" class="login" [nzSuffix]="emergencyCodeTemplate">
                <input [type]="emergencyCodeVisible ? 'text' : 'password'" nz-input name="emergencyCode"
                  i18n-placeholder="Auth.Generic.PlaceholderEmergencyCode|placeholder for emergency code in form@@Auth.Generic.PlaceholderEmergencyCode"
                  placeholder="Codice di emergenza" formControlName="emergencyCode" />
              </nz-input-group>
              <ng-template #emergencyCodeTemplate>
                <i nz-icon [nzType]="emergencyCodeVisible ? 'eye-invisible' : 'eye'"
                  (click)="emergencyCodeVisible = !emergencyCodeVisible"></i>
              </ng-template>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      <div nz-row nzJustify="start" [nzGutter]="20" nzAlign="top">
        <div nz-col nzSpan="24" class="no-form">
          <app-resend-otp
            [disabled]="!validateForm.controls.emergencyCode.valid || timerService.otpSended"
            [validateForm]="validateForm"
            [errorTip]="getValidationErrorMessage(validateForm.controls.otpCode.errors)"
            (isSpinning)="activateSpin($event)"
          ></app-resend-otp>
        </div>
      </div>
      <div nz-row class="confirmIdentity" nzAlign="middle" nzJustify="space-between">
        <a nz-col [nzSpan]="15" class="custom-form-forgot" [routerLink]="getCodeLostLink()"
          i18n="Auth.ResumeIdentity.ForgottenEmergencyCode|link to recovery emergency code@@Auth.ResumeIdentity.ForgottenEmergencyCode"
        >Hai dimenticato il codice di emergenza?</a>
        <div nz-col [nzSpan]="8">
          <button class="submit" nz-button nzType="primary" (click)="submitForm()"
            [disabled]="!validateForm.valid">CONFERMA</button>
        </div>
      </div>
    </form>
  </nz-spin>
</div>
